import { SagaIterator } from "redux-saga";
import { call, put } from "redux-saga/effects";
import { HttpResponseTypeEnum } from "../core/enumerations/ServerRequestStatusEnum";
import { eventsRedux } from "../redux/events-redux/EventsRedux";
import { setError, setSuccessfull } from "../redux/toaster-redux/ToasterRedux";

export function* registerUserInEventSaga(api: any, action: any): SagaIterator {
    const response = yield call(api.registerUserInEvent, action.payload);
    try {
        if (response.status === HttpResponseTypeEnum.Success) {
            yield put(eventsRedux.actions.registerUserForEventsSuccess(response?.data));
            yield put(setSuccessfull(response));
        } else {
            console.log(response, "response?.data")
            yield put(eventsRedux.actions.registerUserForEventsError(response?.data));
            yield put(setError(response));
        }
    } catch (error: any) {
        console.log(error, "line566ERROR")
        yield put(eventsRedux.actions.registerUserForEventsError(error));
    }
}

export function* createRazorpayOrderSaga(api: any, action: any): SagaIterator {
    const response = yield call(api.createOrderRazorpay, action.payload);
    try {
        if (response.status === HttpResponseTypeEnum.Success || response.status === HttpResponseTypeEnum.userCreated) {
            yield put(eventsRedux.actions.createRazorpayOrderSuccess(response?.data));
            yield put(setSuccessfull(response));
        } else {
            yield put(eventsRedux.actions.createRazorpayOrderError(response?.data));
            yield put(setError(response));
        }
    } catch (error: any) {
        yield put(eventsRedux.actions.createRazorpayOrderError(error));
    }
}

export function* verifyPromoCodeSaga(api: any, action: any): SagaIterator {
    const response = yield call(api.verifyPromoCode, action.payload);
    try {
        if (response.status === (HttpResponseTypeEnum.Success || HttpResponseTypeEnum.userCreated)) {
            yield put(eventsRedux.actions.verifyPromoCodeSuccess(response?.data));
            yield put(setSuccessfull(response));
        } else {
            yield put(eventsRedux.actions.verifyPromoCodeError(response?.data));
            yield put(setError(response));
        }
    } catch (error: any) {
        yield put(eventsRedux.actions.verifyPromoCodeError(error));
    }
}

export function* getRefundSaga(api: any, action: any): SagaIterator {
    const response = yield call(api.getEventRefund, action.payload);
    try {
        if (response.status === (HttpResponseTypeEnum.Success || HttpResponseTypeEnum.userCreated)) {
            yield put(eventsRedux.actions.getRefundSuccess(response?.data));
            yield put(setSuccessfull(response));
        } else {
            yield put(eventsRedux.actions.getRefundError(response?.data));
            yield put(setError(response));
        }
    } catch (error: any) {
        yield put(eventsRedux.actions.getRefundError(error));
    }
}